import React, { useEffect, useState } from "react";

//redux
import { connect, useDispatch, useSelector } from "react-redux";

//MUI
import {
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    Tooltip,
} from "@material-ui/core";
import { Cancel } from "@material-ui/icons";

//types
import { CLOSE_WEEKLY_STAR_REWARD_DIALOG } from "../../store/weeklyStar/types";

//component
import RewardTypeSelector from "../RewardTypeSelector";

//action
import { updateWeeklyStarRewards } from "../../store/weeklyStar/action";


const WeeklyStarRewardDialog = (props) => {
    const dispatch = useDispatch();

    const { dialog: open, dialogData } = useSelector((state) => state.weeklyStar);
    const { settings } = useSelector((state) => state.weeklyStar);


    const [rank, setRank] = useState("");
    const [reward, setReward] = useState();
    const [index, setIndex] = useState(null);

    // Reward Type Selector state variables
    const [rewardType, setRewardType] = useState('frame');
    const [selectedFrame, setSelectedFrame] = useState(null);
    const [selectedSvga, setSelectedSvga] = useState(null);
    const [selectedBackground, setSelectedBackground] = useState(null);
    const [selectedGift, setSelectedGift] = useState(null);
    const [selectedGiftCategory, setSelectedGiftCategory] = useState('');
    const [giftQuantity, setGiftQuantity] = useState(0);
    const [validity, setValidity] = useState(1);
    const [validityType, setValidityType] = useState('day');
    const [diamonds, setDiamonds] = useState(1);

    const [errors, setErrors] = useState({
        avatarFrame: "",
        entranceEffect: "",
        background: "",
        diamonds: "",
        validity: "",
        validityType: "",
        gift: "",
    });

    useEffect(() => {
        if (dialogData) {
            setRank(dialogData.rank);
            setReward(dialogData.rewardData);
            setIndex(dialogData.index);
        }
    }, [dialogData]);

    useEffect(
        () => () => {
            setErrors({
                avatarFrame: "",
                entranceEffect: "",
                background: "",
                diamonds: "",
                validity: "",
                validityType: "",
                gift: "",
            });
            setRank("");
            setReward(undefined);
            setIndex(null);
        },
        [open]
    );

    const closePopup = () => {
        dispatch({ type: CLOSE_WEEKLY_STAR_REWARD_DIALOG });
    };

    const handleSubmit = (e) => {

        const errors = {};
        const data = {};

        if (rewardType === 'frame') {
            if (!selectedFrame) {
                errors.avatarFrame = "Avatar Frame is required.";
                errors.validity = "Validity is required.";
                errors.validityType = "Validity Type is required.";
                return setErrors({ ...errors });
            }
            data.type = 'frame';
            data.quantity = 1;
            data.validity = parseInt(validity);
            data.validityType = validityType;
            data.item = selectedFrame.value;
        }

        if (rewardType === 'svga') {
            if (!selectedSvga) {
                errors.entranceEffect = "Entrance Effect is required.";
                errors.validity = "Validity is required.";
                errors.validityType = "Validity Type is required.";
                return setErrors({ ...errors });
            }
            data.type = 'svga';
            data.quantity = 1;
            data.validity = parseInt(validity);
            data.validityType = validityType;
            data.item = selectedSvga.value;
        }


        if (rewardType === 'background') {
            if (!selectedBackground) {
                errors.background = "Background is required.";
                errors.validity = "Validity is required.";
                errors.validityType = "Validity Type is required.";
                return setErrors({ ...errors });
            }
            data.type = 'background';
            data.quantity = 1;
            data.validity = parseInt(validity);
            data.validityType = validityType;
            data.item = selectedBackground.value;
        }

        if (rewardType === 'diamond') {
            if (!diamonds) {
                errors.diamonds = "Diamonds amount is required.";
                return setErrors({ ...errors });
            }
            data.type = 'diamond';
            data.diamond = parseInt(diamonds);
            data.diamondValue = parseInt(diamonds);
        }

        if (rewardType === "gift") {
            if (!giftQuantity || giftQuantity <= 0) {
                errors.giftQuantity = "Gift quantity is required."
                return setErrors({ ...errors });
            }
            data.type = 'gift';
            data.giftQuantity = parseInt(giftQuantity);
            data.item = selectedGift.value;
        }

        const existingRewards = settings?.rewards || {};
        // An index past the end of the list appends a reward to the rank.
        const rankRewards = [...(existingRewards[rank] || [])];
        rankRewards[index] = data;

        const newRewards = {
            ...existingRewards,
            [rank]: rankRewards.filter(Boolean),
        };

        props.updateWeeklyStarRewards(newRewards);
        closePopup();
    }

    return (
        <>
            <Dialog
                open={open}
                aria-labelledby="responsive-dialog-title"
                onClose={closePopup}
                disableBackdropClick
                disableEscapeKeyDown
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle id="responsive-dialog-title">
                    <span className="text-danger font-weight-bold h4"> {reward ? "Update" : "Set"} Reward for {rank} place </span>
                </DialogTitle>

                <IconButton
                    style={{
                        position: "absolute",
                        right: 0,
                    }}
                >
                    <Tooltip title="Close">
                        <Cancel className="text-danger" onClick={closePopup} />
                    </Tooltip>
                </IconButton>
                <DialogContent>
                    <div className="modal-body pt-1 px-1 pb-3">
                        <div className="d-flex flex-column">
                            <form>
                                <RewardTypeSelector
                                    rewardType={rewardType}
                                    setRewardType={setRewardType}
                                    validity={validity}
                                    setValidity={setValidity}
                                    validityType={validityType}
                                    setValidityType={setValidityType}
                                    diamonds={diamonds}
                                    setDiamonds={setDiamonds}
                                    giftQuantity={giftQuantity}
                                    setGiftQuantity={setGiftQuantity}
                                    selectedFrame={selectedFrame}
                                    setSelectedFrame={setSelectedFrame}
                                    selectedSvga={selectedSvga}
                                    setSelectedSvga={setSelectedSvga}
                                    selectedBackground={selectedBackground}
                                    setSelectedBackground={setSelectedBackground}
                                    selectedGift={selectedGift}
                                    setSelectedGift={setSelectedGift}
                                    selectedGiftCategory={selectedGiftCategory}
                                    setSelectedGiftCategory={setSelectedGiftCategory}
                                    errors={errors}
                                />

                                <div className="d-flex justify-content-end gap-3 mt-4">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={closePopup}
                                    >
                                        Cancel
                                    </button>

                                    <button
                                        type="button"
                                        className="btn btn-danger"
                                        onClick={handleSubmit}
                                    >
                                        Save
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </DialogContent>
            </Dialog>
        </>
    );
};

export default connect(null, { updateWeeklyStarRewards })(WeeklyStarRewardDialog);
